import React, { useEffect, useRef, useState } from 'react'
import { RouterProps, useNavigate, useParams, Link } from 'react-router-dom'
import './PagesList.scss'
import { Helmet } from 'react-helmet-async'
import SideMenu from '../components/SideMenu'
import {
  RootState,
  AppDispatch,
  useAppDispatch,
  notesSlice,
  methods,
  configSlice,
  userSlice,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { bindEvent } from '../modules/bindEvent'
import { useTranslation } from 'react-i18next'
import { snackbar, prompt, alert, multiplePrompts } from '@saki-ui/core'

import { Header } from '../components'
import { api } from '../modules/electron/api'
import httpApi from '../modules/http/api'
import { CategoryItem, NoteItem, PageItem } from '../store/notes/typings'
import { ReaderRouterProps } from '../modules/renderRoutes'
import { AES } from '@nyanyajs/utils'
import {
  copyText,
  decryptContent,
  encryptContent,
  getPwd,
} from '../modules/methods'
import { verifyAccountEventListener } from './VerifyAccount'
import { user } from '../protos/proto'
import { getContent } from '../store/notes/methods'
import { getTodoList, getTodoProgress } from '../store/notes/todolist'
import { protoRoot } from '../protos'
import { SakiContextMenuItem, SakiIcon } from './saki-ui-react/components'

const PagesListComponent = ({
  onClick,
  noteId,
  list,
  categoryId,
}: {
  noteId: string
  list: protoRoot.note.IPageItem[]
  categoryId: string
  onClick: ({ id }: { id: string }) => void
}) => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const notes = useSelector((state: RootState) => state.notes)
  const config = useSelector((state: RootState) => state.config)
  const displayItems = useSelector(
    (state: RootState) => state.config.pageConfig.todolistPage.displayItems
  )

  const user = useSelector((state: RootState) => state.user)
  const autoCloseWindowAfterCopy = useSelector(
    (state: RootState) => state.config.general.autoCloseWindowAfterCopy
  )
  let history = useNavigate()
  const ref = useRef<any>(null)
  const [categoryContextMenuEl, setCategoryContextMenuEl] = useState<any>()

  const [selectCTMPage, setSelectCTMPage] = useState<protoRoot.note.IPageItem>()

  const showSelectTypeOfAddPage = useSelector(
    (state: RootState) =>
      state.config.pageConfig.indexPage.showSelectTypeOfAddPage
  )

  const [showContext, setShowContext] = useState({
    x: 0,
    y: 0,
    label: '',
    visible: false,
  })
  const [contextMenuEl, setContextMenuEl] = useState<any>()

  useEffect(() => {
    if (showContext.visible && contextMenuEl) {
      // console.log('showContext.label', showContext.label)
      contextMenuEl?.show({
        x: showContext.x,
        y: showContext.y,
        label: showContext.label,
      })
      return
    }
    setContextMenuEl(undefined)
  }, [showContext.visible, contextMenuEl])

  // const [note, setNote] = useState(
  // 	notes.list?.filter((v) => v.id === noteId)?.[0]
  // )

  // useEffect(() => {
  // 	console.log('notes', '212121212', noteId)
  // 	const note = notes.list?.filter((v) => v.id === noteId)?.[0]
  // 	setNote(note)
  // 	onLoad?.({ note })
  // }, [noteId])

  const onForgotPagePassword = (pageId: string) => {
    const en = 'forgotPassword' + pageId

    dispatch(userSlice.actions.setVerifyAccountEventName(en))

    verifyAccountEventListener.on(en, async (v: any) => {
      console.log(v)

      const res = await httpApi.v1.getPagePassword({
        noteId: noteId,
        pageId,
        token: v,
      })

      console.log('getPagePassword', res)
      if (res.code === 200) {
        let oldPwd = res.data?.password || ''
        let pwd = ''
        const p = multiplePrompts({
          title: t('forgotPassword', {
            ns: 'common',
          }),
          multipleInputs: [
            {
              label: 'pwdInput',
              placeholder: t('newPassword', {
                ns: 'common',
              }),
              type: 'Password',
              value: pwd,
              onChange(value) {
                pwd = value
                if (value) {
                  p.setInput({
                    label: 'pwdInput',
                    type: 'error',
                    v: '',
                  })
                }
                p.setButton({
                  label: 'confirmButton',
                  type: 'disabled',
                  v: !value,
                })
                return ''
              },
            },
          ],
          buttons: [
            {
              label: 'cancelButton',
              text: t('cancel', {
                ns: 'common',
              }),
              onTap() {
                p.close()
              },
            },
            {
              label: 'confirmButton',
              text: t('enableEncryption', {
                ns: 'common',
              }),
              type: 'Primary',
              disabled: true,
              async onTap() {
                if (!pwd) {
                  p.setInput({
                    label: 'pwdInput',
                    type: 'error',
                    v: t('passwordCannotBeEmpty', {
                      ns: 'common',
                    }),
                  })
                  return
                }
                console.log(pwd)

                pwd = getPwd(pwd)

                const res = await httpApi.v1.savePagePassword({
                  noteId: noteId,
                  pageId: pageId,
                  password: pwd,
                })
                console.log('savePagePassword1', res)

                if (res.code === 200) {
                  const page = list.filter((v) => v.id === pageId)?.[0]

                  const content = encryptContent(
                    decryptContent(page.content || '', oldPwd),
                    pwd
                  )

                  dispatch(
                    notesSlice.actions.updatePage({
                      noteId: noteId,
                      categoryId: categoryId,
                      pageId: page.id || '',
                      data: {
                        content: content,
                        // type:
                        // 	!page.type || page.type !== 'Encryption'
                        // 		? 'Encryption'
                        // 		: 'Normal',
                      },
                    })
                  )

                  const obj = {
                    ...notes.pwdObj,
                  }
                  obj[page?.id || ''] = {
                    pwd,
                    validTime:
                      Math.floor(new Date().getTime() / 1000) + 10 * 3600,
                  }
                  dispatch(notesSlice.actions.setPwdObj(obj))
                } else {
                  console.error(res)
                  snackbar({
                    message: res.error || res.msg,
                    vertical: 'top',
                    horizontal: 'center',
                    autoHideDuration: 2000,
                    closeIcon: true,
                  }).open()
                }
                p.close()
              },
            },
          ],
        })

        p.open()
        return
      }
      snackbar({
        message: res.error || res.msg,
        vertical: 'top',
        horizontal: 'center',
        autoHideDuration: 2000,
        closeIcon: true,
      }).open()
    })
  }

  const changeCategoryList = notes.list.filter((v) => {
    return v.id === noteId
  })?.[0]?.categories

  return (
    <div className="pages-list-component">
      <div className="page-subtitle">
        <span>
          {t('pages', {
            ns: 'common',
          })}
        </span>
        {/* <span
					onClick={() => {
						console.log(1)
					}}
				>
					x
				</span> */}
      </div>
      <saki-menu
        ref={bindEvent({
          selectvalue: async (e) => {
            if (
              e.detail.value === 'BlankPage' ||
              e.detail.value === 'TodoList'
            ) {
              return
            }
            dispatch(configSlice.actions.setDisableChangeValue(true))

            // console.log(e.detail.value)
            if (e.detail.value === 'addPage') {
              dispatch(configSlice.actions.setShowSelectTypeOfAddPage(true))

              return
            }

            dispatch(
              notesSlice.actions.selectPage({
                id: e.detail.value,
              })
            )
            onClick({
              id: e.detail.value,
            })
            // setOpenDropDownMenu(false)
          },
        })}
        key={categoryId}
        padding="0px"
      >
        <saki-drag-sort
          ref={bindEvent({
            dragdone: (e) => {
              console.log('dragsort final', e.detail)

              dispatch(
                notesSlice.actions.sortPage({
                  noteId: noteId,
                  categoryId: categoryId,
                  sort: {
                    originalIndex: e.detail.oldIndex,
                    targetIndex: e.detail.newIndex,
                  },
                })
              )
            },
          })}
          sort={
            config.deviceType !== 'Mobile' || config.platform === 'Electron'
          }
          padding="0px"
        >
          {/* <span>
            {list?.length},{list.filter((v) => (v.status || 0) >= 0).length}
          </span> */}
          {/* {config.platform}-{config.deviceType}-
					{String(
						config.deviceType !== 'Mobile' || config.platform === 'Electron'
					)} */}
          {list
            // .filter((v) => (v.status || 0) >= 0)
            .map((v, i) => {
              if ((v.status || 0) < 0) {
                return <div key={i}>{''}</div>
              }
              return (
                <div key={i}>
                  <saki-menu-item
                    ref={bindEvent({
                      opencontextmenu: (e) => {
                        console.log('sortPage', e, i, v)
                        setShowContext({
                          x: e.detail.pageX,
                          y: e.detail.pageY,
                          label: v.id || '',
                          visible: true,
                        })
                        setSelectCTMPage(v)
                      },
                    })}
                    key={i}
                    active={v.id === notes.pageId || v.id === showContext.label}
                    padding="4px 18px"
                    value={v.id}
                  >
                    <div
                      style={{
                        ...(v.type === 'TodoList'
                          ? ({
                              '--todo-progress':
                                getTodoProgress({
                                  categoryId,
                                  noteId,
                                  pageId: v.id || '',
                                }).progress + '%',
                            } as any)
                          : {}),
                      }}
                      className={
                        'pl-item ' +
                        (v.type === 'TodoList' && displayItems.TaskProgressBar
                          ? 'TodoListProgress'
                          : '')
                      }
                    >
                      {(v.encryption || 0) >= 1 ? (
                        <saki-icon
                          color="#999"
                          width="18px"
                          height="18px"
                          margin="0 6px 0 0"
                          type={
                            notes.pwdObj[v.id || '']?.pwd ? 'Unlock' : 'Lock'
                          }
                        ></saki-icon>
                      ) : v.type === 'TodoList' ? (
                        <saki-icon
                          color="#999"
                          width="18px"
                          height="18px"
                          margin="0 6px 0 0"
                          type={'TodoListFill'}
                        ></saki-icon>
                      ) : (
                        ''
                      )}
                      <span className="text-elipsis">
                        {v.title ||
                          t('untitledPage', {
                            ns: 'indexPage',
                          })}
                      </span>
                    </div>
                  </saki-menu-item>
                </div>
              )
            })}
        </saki-drag-sort>

        <saki-dropdown
          visible={showSelectTypeOfAddPage}
          floating-direction="Left"
          z-index="900"
          ref={bindEvent({
            close: (e) => {
              dispatch(configSlice.actions.setShowSelectTypeOfAddPage(false))
            },
          })}
        >
          <saki-menu-item padding="4px 18px" value={'addPage'}>
            <div className={'pl-item text-elipsis add-page'}>
              <span className="text-elipsis">
                {t('addPage', {
                  ns: 'indexPage',
                })}
              </span>
            </div>
          </saki-menu-item>

          <div
            style={{
              width: '200px',
            }}
            slot="main"
          >
            <saki-menu
              ref={bindEvent({
                selectvalue: async (e) => {
                  if (!noteId || !categoryId) {
                    snackbar({
                      message: t('categoryNotYetAdded', {
                        ns: 'indexPage',
                      }),
                      vertical: 'top',
                      horizontal: 'center',
                      autoHideDuration: 2000,
                      closeIcon: true,
                    }).open()
                    return
                  }

                  // console.log(e.detail.value)
                  switch (e.detail.value) {
                    case 'BlankPage':
                      await dispatch(
                        methods.notes.AddPage({
                          noteId: noteId,
                          categoryId: categoryId,
                          type: 'Normal',
                        })
                      ).unwrap()
                      break
                    case 'TodoList':
                      await dispatch(
                        methods.notes.AddPage({
                          noteId: noteId,
                          categoryId: categoryId,
                          type: 'TodoList',
                        })
                      ).unwrap()
                      break

                    default:
                      break
                  }
                  dispatch(
                    configSlice.actions.setShowSelectTypeOfAddPage(false)
                  )
                },
              })}
              padding="0px"
            >
              {[
                {
                  val: 'BlankPage',
                  text: t('blankPage', {
                    ns: 'indexPage',
                  }),
                },
                {
                  val: 'TodoList',
                  text: t('todolist', {
                    ns: 'todoPage',
                  }),
                },
              ].map((v, i) => {
                return (
                  <saki-menu-item
                    padding="14px 18px"
                    font-size="15px"
                    value={v.val}
                    key={i}
                  >
                    <div className={'select-type-item'}>
                      <saki-icon
                        margin="0 6px 0 0"
                        color="#999"
                        type={v.val + 'Fill'}
                      ></saki-icon>
                      <span className="text-elipsis">{v.text}</span>
                    </div>
                  </saki-menu-item>
                )
              })}
            </saki-menu>
          </div>
        </saki-dropdown>
      </saki-menu>

      {showContext.visible ? (
        <saki-context-menu
          ref={bindEvent(
            {
              close: () => {
                setShowContext({
                  x: 0,
                  y: 0,
                  label: '',
                  visible: false,
                })
              },
              selectvalue: async (e) => {
                // console.log('414', e.detail)
                if (e.detail.label === 'ChangeCategoryTo') {
                  dispatch(
                    notesSlice.actions.changePageCategoryTo({
                      noteId: noteId,
                      pageId: e.detail.values[1].label,
                      oldCategoryId: categoryId,
                      newCategoryId: e.detail.value,
                    })
                  )
                  return
                }
                if (e.detail.label === 'SortTo') {
                  const pageId = e.detail.values[1].label
                  switch (e.detail.value) {
                    case 'MoveToTop':
                      list.some((v, i) => {
                        console.log('sortPage MoveToTop', i, v, {
                          originalIndex: i,
                          targetIndex: 0,
                        })
                        if (v.id === pageId) {
                          dispatch(
                            notesSlice.actions.sortPage({
                              noteId: noteId,
                              categoryId: categoryId,
                              sort: {
                                originalIndex: i,
                                targetIndex: 0,
                              },
                            })
                          )
                        }
                        return v.id === pageId
                      })
                      break
                    case 'MoveToBottom':
                      list.some((v, i) => {
                        if (v.id === pageId) {
                          // console.log('sortPage MoveToBottom', i, {
                          //   originalIndex: i - 1,
                          //   targetIndex: list.length - 1,
                          // })
                          dispatch(
                            notesSlice.actions.sortPage({
                              noteId: noteId,
                              categoryId: categoryId,
                              sort: {
                                originalIndex: i,
                                targetIndex: list.length - 1,
                              },
                            })
                          )
                        }
                        return v.id === pageId
                      })
                      break
                  }
                  return
                }
                const page = list.filter((v) => v.id === e.detail.label)?.[0]
                if (!page) return
                switch (e.detail.value) {
                  case 'HistoricalVersion':
                    console.log('HistoricalVersion')

                    dispatch(
                      configSlice.actions.setShowAsideContentModal({
                        visible: true,
                        data: {
                          noteId: noteId,
                          categoryId: categoryId,
                          pageId: e.detail.label,
                          todoId: '',
                          type: 'HistoricalVersion',
                        },
                      })
                    )
                    break
                  case 'forgotPassword':
                    onForgotPagePassword(page.id || '')

                    break
                  case 'encryption':
                    if ((page.encryption || 0) >= 1) {
                      if (notes.pwdObj[page?.id || '']?.pwd) {
                        alert({
                          title: t('reencryptThisPage', {
                            ns: 'common',
                          }),
                          content: t('reencryptThisPageContent', {
                            ns: 'common',
                          }),
                          cancelText: t('cancel', {
                            ns: 'common',
                          }),
                          confirmText: t('reencrypt', {
                            ns: 'common',
                          }),
                          onCancel() {},
                          async onConfirm() {
                            const obj = {
                              ...notes.pwdObj,
                            }
                            delete obj[page.id || '']
                            dispatch(notesSlice.actions.setPwdObj(obj))
                          },
                        }).open()
                        return
                      }
                      let pwd = ''

                      const p = multiplePrompts({
                        title: t('disableEncryption', {
                          ns: 'common',
                        }),
                        multipleInputs: [
                          {
                            label: 'pwdInput',
                            placeholder: t('disableEncryptionPlaceholder', {
                              ns: 'common',
                            }),
                            type: 'Password',
                            value: pwd,
                            onChange(value) {
                              pwd = value
                              if (value) {
                                p.setInput({
                                  label: 'pwdInput',
                                  type: 'error',
                                  v: '',
                                })
                              }
                              p.setButton({
                                label: 'confirmButton',
                                type: 'disabled',
                                v: !value,
                              })
                              return ''
                            },
                          },
                        ],
                        buttons: [
                          {
                            label: 'cancelButton',
                            text: t('cancel', {
                              ns: 'common',
                            }),
                            onTap() {
                              p.close()
                            },
                          },
                          {
                            label: 'forgotPasswordButton',
                            text: t('forgotPassword', {
                              ns: 'common',
                            }),
                            border: '1px solid var(--saki-default-color)',
                            color: 'var(--saki-default-color)',
                            onTap() {
                              onForgotPagePassword(page.id || '')
                            },
                          },
                          {
                            label: 'confirmButton',
                            text: t('disableEncryption', {
                              ns: 'common',
                            }),
                            type: 'Primary',
                            disabled: true,
                            async onTap() {
                              if (!pwd) {
                                p.setInput({
                                  label: 'pwdInput',
                                  type: 'error',
                                  v: t('passwordCannotBeEmpty', {
                                    ns: 'common',
                                  }),
                                })
                                return
                              }

                              console.log('验证密码', pwd)

                              pwd = getPwd(pwd)

                              const content = decryptContent(
                                page.content || '',
                                pwd
                              )

                              if (!content) {
                                p.setInput({
                                  label: 'pwdInput',
                                  type: 'error',
                                  v: t('wrongPasswordPleaseReEnter', {
                                    ns: 'common',
                                  }),
                                })
                                return
                              }

                              dispatch(
                                notesSlice.actions.updatePage({
                                  noteId: noteId,
                                  categoryId: categoryId,
                                  pageId: page.id || '',
                                  data: {
                                    encryption: -1,
                                    content: content,
                                  },
                                })
                              )

                              await httpApi.v1.deletePagePassword({
                                noteId: noteId,
                                pageId: page.id,
                                password: pwd,
                              })

                              const obj = {
                                ...notes.pwdObj,
                              }
                              delete obj[page.id || '']
                              dispatch(notesSlice.actions.setPwdObj(obj))

                              p.close()
                            },
                          },
                        ],
                      })

                      p.open()
                    } else {
                      let pwd = ''
                      const p = multiplePrompts({
                        title: t('enableEncryption', {
                          ns: 'common',
                        }),
                        multipleInputs: [
                          {
                            label: 'pwdInput',
                            placeholder: t('enableEncryptionPlaceholder', {
                              ns: 'common',
                            }),
                            type: 'Password',
                            value: pwd,
                            onChange(value) {
                              pwd = value
                              if (value) {
                                p.setInput({
                                  label: 'pwdInput',
                                  type: 'error',
                                  v: '',
                                })
                              }
                              p.setButton({
                                label: 'confirmButton',
                                type: 'disabled',
                                v: !value,
                              })
                              return ''
                            },
                          },
                        ],
                        buttons: [
                          {
                            label: 'cancelButton',
                            text: t('cancel', {
                              ns: 'common',
                            }),
                            onTap() {
                              p.close()
                            },
                          },
                          {
                            label: 'confirmButton',
                            text: t('enableEncryption', {
                              ns: 'common',
                            }),
                            type: 'Primary',
                            disabled: true,
                            async onTap() {
                              if (!pwd) {
                                p.setInput({
                                  label: 'pwdInput',
                                  type: 'error',
                                  v: t('passwordCannotBeEmpty', {
                                    ns: 'common',
                                  }),
                                })
                                return
                              }

                              pwd = getPwd(pwd)

                              console.log('getPwd', pwd)

                              const res = await httpApi.v1.savePagePassword({
                                noteId: noteId,
                                pageId: page.id,
                                password: pwd,
                              })
                              console.log('savePagePassword1', res)

                              if (res.code === 200) {
                                const content = encryptContent(
                                  page.content || '',
                                  pwd
                                )

                                console.log('savePagePassword1', content)
                                const enContent = decryptContent(content, pwd)
                                console.log('savePagePassword1', enContent)

                                const obj = {
                                  ...notes.pwdObj,
                                }
                                delete obj[page?.id || '']

                                dispatch(notesSlice.actions.setPwdObj(obj))

                                dispatch(
                                  notesSlice.actions.updatePage({
                                    noteId: noteId,
                                    categoryId: categoryId,
                                    pageId: page.id || '',
                                    data: {
                                      content: content,
                                      encryption: 2,
                                      // type:
                                      // 	!page.type || page.type !== 'Encryption'
                                      // 		? 'Encryption'
                                      // 		: 'Normal',
                                    },
                                  })
                                )
                              } else {
                                console.error(res)
                                snackbar({
                                  message: res.error || res.msg,
                                  vertical: 'top',
                                  horizontal: 'center',
                                  autoHideDuration: 2000,
                                  closeIcon: true,
                                }).open()
                              }
                              p.close()
                            },
                          },
                        ],
                      })

                      p.open()
                    }

                    break
                  case 'delete':
                    alert({
                      title: t('delete', {
                        ns: 'common',
                      }),
                      content: t('deleteThisPage', {
                        ns: 'common',
                      }),
                      cancelText: t('cancel', {
                        ns: 'common',
                      }),
                      confirmText: t('delete', {
                        ns: 'common',
                      }),
                      onCancel() {},
                      async onConfirm() {
                        dispatch(
                          configSlice.actions.setDisableChangeValue(true)
                        )
                        dispatch(
                          notesSlice.actions.deletePage({
                            noteId: noteId,
                            categoryId: categoryId,
                            pageId: page?.id || '',
                          })
                        )
                      },
                    }).open()
                    break

                  default:
                    break
                }
              },
            },
            (e) => {
              setContextMenuEl(e)
            }
          )}
        >
          {/* <saki-menu
					ref={bindEvent({
						selectvalue: (e) => {
							console.log(e)
							pageContextMenuEl?.hide()
						},
					})}
				>
					{[5, 4, 3, 2, 1, -1].map((v, i) => {
						return (
							<saki-menu-item font-size='14px' value={v} key={i}>
								<saki-icon type={!v ? 'Star' : 'StarFill'}></saki-icon>
							</saki-menu-item>
						)
					})}
				</saki-menu> */}
          <saki-context-menu-item
            font-size="13px"
            padding="12px 10px"
            value="encryption"
            hide={!user.isLogin || selectCTMPage?.type === 'TodoList'}
          >
            <div className="context-menu-item">
              <saki-icon
                margin="0 6px 0 0"
                width="18px"
                height="18px"
                color="#999"
                type={(selectCTMPage?.encryption || 0) >= 1 ? 'Unlock' : 'Lock'}
              ></saki-icon>
              <span>
                {(selectCTMPage?.encryption || 0) >= 1
                  ? notes.pwdObj[selectCTMPage?.id || '']?.pwd
                    ? t('reencrypt', {
                        ns: 'common',
                      })
                    : t('disableEncryption', {
                        ns: 'common',
                      })
                  : t('enableEncryption', {
                      ns: 'common',
                    })}
              </span>
            </div>
          </saki-context-menu-item>

          <saki-context-menu-item
            font-size="13px"
            padding="12px 10px"
            value="forgotPassword"
            hide={!user.isLogin || !selectCTMPage?.encryption}
          >
            <div className="context-menu-item">
              <saki-icon
                margin="2px 6px 0 0"
                width="18px"
                height="14px"
                color="#999"
                type={'Question'}
              ></saki-icon>
              <span>
                {t('forgotPassword', {
                  ns: 'common',
                })}
              </span>
            </div>
          </saki-context-menu-item>

          <saki-context-menu-item
            font-size="13px"
            padding="12px 10px"
            value="SortTo"
          >
            <div className="context-menu-item">
              <saki-icon
                margin="2px 6px 0 0"
                width="18px"
                height="14px"
                type={'Sort'}
              ></saki-icon>
              <span>
                {t('sortTo', {
                  ns: 'sakiuiPrompt',
                })}
              </span>
            </div>
            <div slot="SubMenu">
              <saki-context-menu label="SortTo">
                {[
                  {
                    icon: 'MoveTop',
                    value: 'MoveToTop',
                    text: t('moveToTop', {
                      ns: 'sakiuiPrompt',
                    }),
                  },
                  {
                    icon: 'MoveBottom',
                    value: 'MoveToBottom',
                    text: t('moveToBottom', {
                      ns: 'sakiuiPrompt',
                    }),
                  },
                ].map((v, i) => {
                  return (
                    <saki-context-menu-item
                      key={i}
                      font-size="13px"
                      padding="12px 10px"
                      value={v.value}
                    >
                      <div className="context-menu-item">
                        <saki-icon margin="0 6px 0 0" type={v.icon}></saki-icon>
                        <span>{v.text}</span>
                      </div>
                    </saki-context-menu-item>
                  )
                })}
              </saki-context-menu>
            </div>
          </saki-context-menu-item>

          <saki-context-menu-item
            font-size="13px"
            padding="12px 10px"
            value="ChangeCategoryTo"
          >
            <div className="context-menu-item">
              <saki-icon
                height="14px"
                margin="0 6px 0 0"
                type="MoveTo"
              ></saki-icon>
              <span>
                {t('changeCategoryTo', {
                  ns: 'common',
                })}
              </span>
            </div>
            <div slot="SubMenu">
              <saki-context-menu label="ChangeCategoryTo">
                {notes.list
                  .filter((v, i) => {
                    return v.id === noteId
                  })?.[0]
                  ?.categories?.map((v, i) => {
                    return (
                      <saki-context-menu-item
                        key={i}
                        font-size="13px"
                        padding="12px 10px"
                        value={v.id}
                      >
                        <div className="context-menu-item">
                          <span>{v.name}</span>
                        </div>
                      </saki-context-menu-item>
                    )
                  })}
              </saki-context-menu>
            </div>
          </saki-context-menu-item>

          <SakiContextMenuItem
            font-size="13px"
            padding="12px 10px"
            value="HistoricalVersion"
            hide={
              !(
                user.isLogin &&
                notes.list?.filter((v) => v.id === noteId)?.[0]?.isSync
              )
            }
          >
            <div className="context-menu-item">
              <SakiIcon
                color="#666"
                width="17px"
                height="17px"
                margin="0 6px 0 0"
                type="Time"
              ></SakiIcon>
              <span>
                {t('pageTitle', {
                  ns: 'historicalVersionPage',
                })}
              </span>
            </div>
          </SakiContextMenuItem>
          <saki-context-menu-item
            font-size="13px"
            padding="12px 10px"
            value="delete"
          >
            <div className="context-menu-item">
              <saki-icon margin="0 6px 0 0" type="Trash"></saki-icon>
              <span>
                {t('delete', {
                  ns: 'common',
                })}
              </span>
            </div>
          </saki-context-menu-item>
        </saki-context-menu>
      ) : (
        ''
      )}
    </div>
  )
}

export default PagesListComponent
